// @flow
import * as React from 'react';
import { SelectInput as Source, SelectInputProps } from '@coverright/ui/inputs';
import { TickIcon } from './tick-icon';


export const SelectInput = (props: SelectInputProps) => (
  <Source {...props} tickIcon={<TickIcon />} />
)
